import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";

const Indienen = ({ match }) => {
    return (

        <Outlet />
    )
};

export default Indienen;
